import {Component} from "react";
import {Table} from "react-bootstrap";
import {PasswordRequirementNames, PasswordScore} from "../CalculatePasswordScore";
import PasswordCheckStatusImage from "./PasswordCheckStatusImage";

export interface PasswordScoreAdditionsProps{
    score: PasswordScore
}
export default class PasswordScoreAdditions extends Component<PasswordScoreAdditionsProps> {

    render() {
        const showScore = (score: number | undefined) => (score || 0) > 0 ? `+${score}` : `${score}`;
        const requirementsTableRow = (requirement: PasswordRequirementNames, otherRows: JSX.Element) => {
            return <>
                <td><PasswordCheckStatusImage status={this.props.score.requirements[requirement].status} /></td>
                {otherRows}
                <td><div>{this.props.score.requirements[requirement].count}</div></td>
                <td className={this.props.score.requirements[requirement].status}>{showScore(this.props.score.requirements[requirement].score)}</td>
            </>
        }
        return <>
            <Table bordered className="score-details">
                <thead>
                <tr>
                    <th colSpan={2}>Additions</th>
                    <th>Type</th>
                    <th>Rate</th>
                    <th>Count</th>
                    <th>Bonus</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    {requirementsTableRow('NumberOfCharacters',<>
                        <td>Number of Characters</td>
                        <td>Flat</td>
                        <td>+(n*4)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('UppercaseLetters',<>
                        <td>Uppercase Letters</td>
                        <td>Cond/Incr</td>
                        <td>+((len-n)*2)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('LowercaseLetters',<>
                        <td>Lowercase Letters</td>
                        <td>Cond/Incr</td>
                        <td>+((len-n)*2)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('Numbers',<>
                        <td>Numbers</td>
                        <td>Cond</td>
                        <td>+(n*4)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('Symbols',<>
                        <td>Symbols</td>
                        <td>Flat</td>
                        <td>+(n*6)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('MiddleNumbersOrSymbols',<>
                        <td>Middle Numbers or Symbols</td>
                        <td>Flat</td>
                        <td>+(n*2)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('Requirements',<>
                        <td>Requirements</td>
                        <td>Flat</td>
                        <td>+(n*2)</td>
                    </>)}
                </tr>
                </tbody >
            </Table >
        </>
    }
}
